// 一对一询问订单
// const SERVICE_ORDER_INPUT = 'SERVICE_ORDER_INPUT' // 输入问题描述或联系电话
const SERVICE_TYPE = "SERVICE_TYPE" // 问题类型变化
// 初始化用户信息
const OWER_VIEW_INIT = "OWER_VIEW_INIT"
const USER_PROFILE = "USER_PROFILE" // 用户完整信息
const VIP_USER_INFO = "VIP_USER_INFO" // vip用户信息

// 初始化宠物信息
const PET_LIST_INIT = "PET_LIST_INIT"
const PET_VIEW = "PET_VIEW"

const CHANGE_IMG_LIST = "CHANGE_IMG_LIST"

export default {
    [OWER_VIEW_INIT](state, ownerView) {
        state.ownerView = ownerView
    },
    [VIP_USER_INFO](state, vipUserInfo) {
        state.vipUserInfo = vipUserInfo
    },
    [USER_PROFILE](state, userProfile) {
        state.userProfile = userProfile
    },
    [PET_LIST_INIT](state, petList) {
        state.petList = petList
    },
    [CHANGE_IMG_LIST](state, { img, sign }) {
        if (sign == "+") {
            state.imgList.push(img.imgUrl)
        } else if (sign == "-") {
            for (let i = 0; i < state.imgList.length; i++) {
                if (state.imgList[i].id === img.id) {
                    state.imgList.splice(i, 1)
                    break
                }
            }
        }
    },
    [PET_VIEW](state, { petView }) {
        state.petView = petView
    },
}



// WEBPACK FOOTER //
// ./src/store/mutations.js